import { Fade } from "@mui/material";
import { Button, ButtonProps, CircularProgress, Box } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";

export function WorkerButton({
  working,
  disabled,
  children,
  ...other
}: { working?: boolean; disabled?: boolean } & ButtonProps) {
  const [showLoader, setShowLoader] = useState<boolean>(false);

  useEffect(() => {
    if (working) {
      const to = setTimeout(() => {
        setShowLoader(true);
      }, 1000);
      return () => {
        clearTimeout(to);
      };
    } else {
      setShowLoader(false);
    }
  }, [working]);

  return (
    <Button {...other} disabled={working || disabled}>
      {working && (
        <Fade in={showLoader}>
          <Box component="span" sx={styles.container}>
            <CircularProgress
              variant="indeterminate"
              sx={styles.progress}
              thickness={5}
            />
          </Box>
        </Fade>
      )}
      {children}
    </Button>
  );
}

export default WorkerButton;

const styles = {
  container: {
    maxWidth: 24,
    maxHeight: 24,
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
  },
  progress: {
    color: "grey.500",
    maxWidth: 24,
    maxHeight: 24,
  },
  content: {
    marginLeft: "12px",
  },
} as const;
